import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
} from '@fortawesome/pro-solid-svg-icons';

import PopoverTrigger from '../../PopoverTrigger';


export default function ChartInfoPopover(props) {
  const { title, body } = props;

  return (
    <PopoverTrigger
      rootClose={true}
      popoverTitle={title}
      popoverContent={
        <div>
          {body}
        </div>
      }
      trigger={'click'}
      placement='right'
    >
      <FontAwesomeIcon
        style={{
          fontSize: '18px',
          color: 'var(--et_tab_grey)',
          marginLeft: '5px',
          cursor: 'pointer',
        }}
        icon={faInfoCircle}
      />
    </PopoverTrigger>)
}